import styled from 'styled-components';
import { darken, rem } from 'polished';
import { transition } from '../../mixins';
export var StyledButtonIcon = styled.button.withConfig({
  displayName: "ButtonIconstyle__StyledButtonIcon",
  componentId: "sc-1ksjl0r-0"
})(["", ";border:1px solid transparent;border-radius:", ";box-sizing:border-box;display:inline-flex;align-content:center;justify-content:center;width:", ";height:", ";padding:", ";svg{fill:", ";color:", ";width:", ";height:", ";align-self:center;}", ""], transition(), function (_ref) {
  var theme = _ref.theme;
  return theme.radius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spaces.xxlg;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spaces.xxlg;
}, rem('4px'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spaces.lg;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spaces.lg;
}, getVariant);

function getVariant(_ref8) {
  var variant = _ref8.variant,
      theme = _ref8.theme,
      isOnDarkBg = _ref8.isOnDarkBg;

  // IF the background is dark, we use white regardless of the original color.
  if (isOnDarkBg) {
    return getWhiteStyle(theme);
  }

  switch (variant) {
    case 'black':
      return getBlackStyle(theme);

    case 'primary':
      return getPrimaryStyle(theme);
  }
}

function getStyle(baseColor) {
  return "\n    background: transparent;\n    svg {\n      ".concat(transition(), ";\n      fill: ").concat(baseColor, ";\n      color: ").concat(baseColor, ";\n    }\n  ");
}

function getBlackStyle(theme) {
  var _theme$color = theme.color,
      black = _theme$color.black,
      grey30 = _theme$color.grey30,
      grey50 = _theme$color.grey50;
  return "\n    ".concat(getStyle(black), "\n    ").concat(getStates(grey30, grey50), "\n    ").concat(getFocusStates(black, grey50, theme), "\n    ").concat(getActiveStates(grey30, grey50), "\n  ");
}

function getPrimaryStyle(theme) {
  var _theme$color2 = theme.color,
      primary = _theme$color2.primary,
      grey50 = _theme$color2.grey50;
  return "\n    ".concat(getStyle(primary), "\n    ").concat(getStates(darken(theme.darkenPercentage.hover, primary), grey50), "\n    ").concat(getFocusStates(primary, primary, theme), "\n    ").concat(getActiveStates(darken(theme.darkenPercentage.hover, primary), primary), "\n  ");
}

function getWhiteStyle(theme) {
  var _theme$color3 = theme.color,
      white = _theme$color3.white,
      grey90 = _theme$color3.grey90,
      grey50 = _theme$color3.grey50;
  return "\n    ".concat(getStyle(white), "\n    ").concat(getStates(grey90, grey50), "\n    ").concat(getFocusStates(white, grey50, theme), "\n    ").concat(getActiveStates(grey90, grey50), "\n  ");
}

function getActiveStates(color, shadow) {
  return "\n    &:active {\n      background: transparent;\n      box-shadow: inset 0px 0px 0px 3px ".concat(shadow, ";\n      svg {\n        fill: ").concat(color, ";\n        color: ").concat(color, ";\n      }\n    }\n  ");
}

function getStates(color, border) {
  return "\n    &:hover:not(:focus),\n    &:active:not(:focus) {\n      border: 1px solid ".concat(border, ";\n      svg {\n        fill:  ").concat(color, ";\n        color:  ").concat(color, ";\n      }\n    }\n\n    &:hover,\n    &:active {\n      cursor: pointer;\n    }\n  ");
}

function getFocusStates(color, shadow, theme) {
  return "\n    &:focus {\n      outline-color: transparent;\n      outline-style: solid;\n      background: transparent;\n      box-shadow: inset 0px 0px 0px 3px ".concat(shadow, ";\n      svg {\n        fill: ").concat(color, ";\n        color: ").concat(color, ";\n      }\n    }\n\n    @media (forced-colors: active) and (prefers-color-scheme: light) {\n      &&:focus {\n        svg {\n          color: ").concat(theme.color.black, ";\n        }\n      }\n    }\n    @media (forced-colors: active) and (prefers-color-scheme: dark) {\n      &&:focus {\n        svg {\n          color: ").concat(theme.color.white, ";\n        }\n      }\n    }\n  ");
}